import { ScrollTrigger } from "gsap/ScrollTrigger";

const NAVBAR_OFFSET_FALLBACK = 88;
const EXTRA_SCROLL_MARGIN = 24;
const HASH_EXTRA_OFFSETS: Record<string, number> = {
  faq: 200,
  depoimentos: -150,
};
const STACKING_VIEWPORT_TOLERANCE = 1.05;

function getAnchorTop(element: HTMLElement) {
  ScrollTrigger.refresh();

  const stackedSection = element.closest(".gsap-stack");

  if (stackedSection instanceof HTMLElement) {
    const stackedTrigger = ScrollTrigger.getAll().find(
      (trigger) => trigger.pin && trigger.trigger === stackedSection,
    );

    if (stackedTrigger) {
      const sectionRect = stackedSection.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const relativeOffset = elementRect.top - sectionRect.top;
      const viewportHeight = window.innerHeight;
      const sectionHeight = Math.max(stackedSection.offsetHeight, stackedSection.scrollHeight);
      const fitsViewport = sectionHeight <= viewportHeight * STACKING_VIEWPORT_TOLERANCE;
      const stackedOverflow = fitsViewport ? 0 : Math.max(sectionHeight - viewportHeight, 0);
      const sectionTop = stackedTrigger.start - stackedOverflow;

      return sectionTop + relativeOffset;
    }
  }

  return element.getBoundingClientRect().top + window.scrollY;
}

export function scrollToHashTarget(hash: string, behavior: ScrollBehavior = "smooth") {
  if (typeof window === "undefined") return false;

  const id = hash.replace(/^#/, "").trim();
  if (!id) return false;

  const element = document.getElementById(id);
  if (!element) return false;

  const nav = document.querySelector("nav");
  const navHeight = nav instanceof HTMLElement ? nav.offsetHeight : NAVBAR_OFFSET_FALLBACK;
  const extraHashOffset = HASH_EXTRA_OFFSETS[id] ?? 0;
  const top = getAnchorTop(element) - navHeight - EXTRA_SCROLL_MARGIN - extraHashOffset;

  window.scrollTo({
    top: Math.max(top, 0),
    behavior,
  });

  return true;
}
